import React, { memo, ReactNode } from 'react';

import SimpleList from '@plasma/ui.display.simple-list';
import PopConfirm from '@plasma/ui.feedback.pop-confirm';
import Button from '@plasma/ui.general.button';
import SearchInput from '@plasma/ui.input.search-input';
import Modal from '@plasma/ui.layout.modal';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import EditableTable from '../../components/edit-table';
import LoadingComponent from '../../components/Loding-component/LoadingComponent';
import { supplierValue } from '../../components/supplierInfo';
import TopBarThemed from '../../components/top-bar-themed';
import useShoppingCartHook from './shopping-cart.hook';
import { NormalPlasmaButton } from './shopping-cart.styles';
import * as styled from './shopping-cart.styles';
import themes from './themes';
import 'antd/dist/antd.css';
import { Skeleton } from 'antd';

export interface ShoppingCartProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

type Props = ShoppingCartProps & ThemeOverride;

function ShoppingCart(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const {
    t,
    dataForColumns,
    dataForModal,
    columnNames,
    area,
    zone,
    source,
    setQuantIndex,
    usedProfilesForCode,
    handleGoHome,
    viewDrawing,
    handleDrawingModal,
    handleDrawingModalCancel,
    search,
    setSearch,
    clickedRow,
    setClickedRow,
    showModal,
    setshowModal,
    showCodeModal,
    setshowCodeModal,
    HandleCodeModalCancel,
    handleSelection,
    HandleModalCancel,
    handleGenerateRFQ,
    handleRFQSend,
    handleRFQModalCancel,
    handleRFQModalDelete,
    codeModalTitle,
    dropdownOptions,
    descriptionForCode,
    usedEquipmentsForCode,
    selectedValue,
    gridQuantity,
    setGridQuantity,
    showRFQModal,
    lineseqData,
    equipNameSet,
    consumeSet,
    quantIndex,
    iFrameSrc,
    totalQuantity,
    iFrameSrcForCode,
    selectedEquipment,
    sendMailButtonLoading,
    lastPage,
    pageLoading,
    handleUp,
    handleDown,
    handleOk,
    handleRemoveAll,
    handleDeleteLine,
    handleGoBack,
    handleSupplierInfoModal,
    handleSupplierInfoModalCancel,
    showSupplierInfoModal,
    justCloseRfqModal
  } = useShoppingCartHook(props);

  const tableHeadingStyles: React.CSSProperties = {
    borderLeft: '1px solid #ccc',
    textAlign: 'left',
    padding: '8px',
  };

  const handleQuantityChange = (index, newQuantity) => {
    const updatedGridQuantity = [...gridQuantity];
    updatedGridQuantity[index] = newQuantity;

    setGridQuantity(updatedGridQuantity);
  };
  //console.log(dataForColumns);
  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.ShoppingCart className={`shopping-cart ${className ?? ''}`.trim()} style={style}>

      {pageLoading && <LoadingComponent/>}

        <TopBarThemed
          topHeading={t("shopping-cart")}
        />

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '2vh' }}>
          <SearchInput
            style={{
              width: '20vw',
              marginLeft: '5px'
            }}
            placeholder={t("search-with-consumables")}
            onSearch={(data) => {
              setSearch(data);
            }}
          />
          { ( dataForModal.length>0) ? (
          <div style={{
            borderRight: '1px solid black',
            borderLeft: '1px solid black',
            borderRadius: '2px',
            backgroundColor: 'white',
            height:'2.5vh',
            color: 'black',
            fontSize:'1.4vh',
            fontWeight: 'bold',
            padding: '0 1vh 0 1vh',
            marginRight: '8%'
          }}>
              {t("total-quantity")} : {totalQuantity}
          </div>
          ) : ''
          }
          <div style={{display: 'flex', marginRight: '0.5vw'}}>
            <NormalPlasmaButton
              title={t("reset-cart")}
              prefixIcon={{name: 'refresh'}}
              onClick={()=> handleRFQModalDelete()}
            />

            <NormalPlasmaButton
              style={{marginLeft: '1vw'}}
              title={t("generate-RFQ")}
              onClick={handleGenerateRFQ}
              disabled={!(dataForColumns && dataForColumns.length)}
            />

            {
              lastPage !== '0' &&
              <NormalPlasmaButton
              style={{marginLeft: '1vw', width: ''}}
              suffixIcon={{name: 'miscellaneous_services'}}
              prefixIcon={{name: 'redo'}}
              title={lastPage === 'overview' ? t("consumable-overview") : t("planned-demand")}
              onClick={handleGoBack}
            />
            }

          </div>
        </div>

          <div>
          {(dataForColumns && dataForColumns.length) ?
            (
              <EditableTable
                tableData={dataForColumns}
                tableColumns={columnNames}
                showActions_ext={false}
                allowSelection
                selectInputReturnType={'value'}
                showLoadingOnSelection={false}
                hiddenColumns={[]}
                handleSelection={handleSelection}
                clearTheSelection
              />
            )
            :
            (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '60vh',
                fontSize: '30px',
                background: 'linear-gradient(to right, #ff0000, #0000ff, #ffff00)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
            }}>
                {pageLoading ? '' : t("so-light")}
            </div>
            )
          }
          </div>


        <Modal
          title={`${t("consumable-code")} ${clickedRow}`}
          width={'60%'}
          okText={t("save")}
          cancelText={t("cancel")}
          visible={showModal}
          onCancel={() => HandleModalCancel()}
          onOk={() => handleOk()}
          destroyOnClose
          footer = {
            <div style={{display: 'flex', columnGap: '10px'}}>
              <PopConfirm
                //title = 'Are you sure you want to delete this family ?'
                title={<div>{t('remove-confirmation-text')} ?</div>}
                onConfirm={handleRemoveAll}
                okText={t("remove")}
                cancelText={t("cancel")}
              >
                <NormalPlasmaButton
                  title={t("remove-all")}
                  prefixIcon={{name: 'delete'}}
                />
              </PopConfirm>
              <NormalPlasmaButton
                title={t("cancel")}
                prefixIcon={{name: 'cancel'}}
                onClick={() => HandleModalCancel()}
              />
              <NormalPlasmaButton
                title={t("save")}
                prefixIcon={{name: 'save'}}
                onClick={() => handleOk()}
              />
            </div>
          }
        >
          {pageLoading && <LoadingComponent/>}
          <div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              background: 'linear-gradient(to top left, #f0f0f5, #33adff34)',
              padding: '20px',
              borderRadius: '5px',
            }}
          >
              <table style={{border: '1px solid #ccc', borderCollapse: 'collapse', marginLeft: '2px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#eee' }}>
                    <th style={tableHeadingStyles}>{t("sl-no")}</th>
                    <th style={tableHeadingStyles}>{t("area")}</th>
                    <th style={tableHeadingStyles}>{t("zone")}</th>
                    <th style={tableHeadingStyles}>{t("equipment")} {t("name")}</th>
                    <th style={tableHeadingStyles}>{t("consumable")} {t("name")}</th>
                    <th style={tableHeadingStyles}>{t("profile")}</th>
                    <th style={tableHeadingStyles}>{t("source")}</th>
                    <th style={tableHeadingStyles}>{t("quantity")}</th>
                    <th style={tableHeadingStyles} />
                  </tr>
                </thead>
                <tbody>
                  {dropdownOptions.map((option, index) => {
                    return (
                      <tr
                        key={index}
                        style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#eee' }}
                      >
                        <td
                          style={{ cursor: 'pointer', padding: '8px', width: '3vw' }}
                        >
                          <div>{lineseqData[index]}</div>
                        </td>
                        <td
                          style={{borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '15.5vw' }}
                        >
                          <div>{area[index]}</div>
                        </td>
                        <td
                          style={{borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px',  width: '15.5vw' }}
                        >
                          <div>{zone[index]}</div>
                        </td>
                        <td
                          style={{borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px',  width: '15.5vw' }}
                        >
                          <div>{equipNameSet[index]}</div>
                        </td>
                        <td
                          style={{borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px',  width: '15.5vw' }}
                        >
                          <div>{consumeSet[index]}</div>
                        </td>
                        <td
                          style={{borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '25.5vw' }}
                        >
                          {option}
                        </td>
                        <td
                          style={{borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px', width: '15.5vw' }}
                        >
                          <div>{source[index]}</div>
                        </td>
                        <td
                          style={{borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px',  width: '5.5vw' }}
                        >
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' ,marginRight: '2px'}}>
                            <div
                              style={{
                                backgroundColor: gridQuantity[index] === 0 ? 'grey' : '#f0f5f5',
                                borderTop: '1px solid black',
                                borderBottom: '1px solid black',
                                borderLeft: '1px solid black',
                                borderRadius: '2px',
                                borderTopLeftRadius: '8px',
                                borderBottomLeftRadius: '8px',
                                width: '2vw',
                                height: '26px',
                                color: gridQuantity[index] === 0 ? 'white' : 'red',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              {/* Display quantIndex state variable */}
                              {gridQuantity[index]}
                            </div>
                            <div>
                              {/* Button component */}
                              <Button
                                htmlType={'button'}
                                prefixIcon={{ name: 'keyboard_arrow_up' }}
                                style={{ width: '20px', height: '13px', borderLeft: 'none', borderBottom: 'none' }}
                                type={'secondary'}
                                onClick={() => {
                                  // handleQuantityChange(index, gridQuantity[index] + 1);
                                  handleUp(index, parseFloat(gridQuantity[index]) + 1);
                                }}
                              />
                              <Button
                                htmlType={'button'}
                                prefixIcon={{ name: 'keyboard_arrow_down' }}
                                style={{width: '20px', height: '13px', borderLeft: 'none', borderTop:'none'}}
                                type={'secondary'}
                                onClick={() => {
                                  handleDown(index, parseFloat(gridQuantity[index]) - 1);
                                }}
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          style={{borderLeft: '1px solid #ccc', cursor: 'pointer', padding: '8px' }}
                        >
                          <div>
                            <PopConfirm
                              //title = 'Are you sure you want to delete this family ?'
                              title={<div>{t('remove-confirmation-text-it')} ?</div>}
                              okText={t("remove")}
                              cancelText={t("cancel")}
                              onConfirm={() => handleDeleteLine(index)}
                            >
                              <Button
                                type='tertiary'
                                prefixIcon={{name: 'delete'}}
                                disabled={gridQuantity[index]===0}
                              />
                            </PopConfirm>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
        <Modal
          title={`${t("consumable")} ${codeModalTitle} ${t("main-data")}`}
          width={'max-content'}
          cancelText={t("cancel")}
          visible={showCodeModal}
          onCancel={() => HandleCodeModalCancel()}
          onOk={() => HandleCodeModalCancel()}
          footer={null}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              background: 'linear-gradient(to top left, #f0f0f5, #33adff34)',
              padding: '15px 20px 20px 20px',
              borderRadius: '5px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px', marginTop: '20px' }}>
              <div
                style={{
                  width: '10.5vw',
                  fontWeight: 'bold',
                  marginRight: '52px',
                  fontSize: '15px',
                  border: '1px solid #75a3a3',
                  backgroundColor: '#f0f5f5',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                {t("description")}
              </div>
              <div
                style={{
                  fontWeight: 'bold',
                  width: 'max-content',
                  marginRight: '5px',
                  padding: '5px',
                  backgroundColor: 'white',
                  borderRadius: '5px',
                  border: '1px solid #75a3a3',
                }}
              >
                {descriptionForCode}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
              <div
                style={{
                  width: '10.5vw',
                  fontWeight: 'bold',
                  marginRight: '40px',
                  fontSize: '15px',
                  border: '1px solid #75a3a3',
                  backgroundColor: '#f0f5f5',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                {t("used-in")}
              </div>
              <SimpleList
                dataSource={usedEquipmentsForCode}
                style={{
                  overflowX: 'auto',
                  overflowY: 'auto',
                  maxHeight: '14.5vh',
                  width: '21vw',
                  borderColor: '#8b8b8c',
                  borderRadius: '5px',
                }}
                renderItem={(item) => (
                  <div
                    style={{
                      marginLeft: '10px',
                      marginTop: '5px',
                      display: 'flex',
                      padding: '2px',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                      <div
                        style={{
                          width: '19vw',
                          marginRight: '5px',
                          padding: '2px',
                          backgroundColor: 'white',
                          borderRadius: '5px',
                          border: '1px solid #75a3a3',
                        }}
                      >
                        {item.equipmentcode} : {item.zonecode} : {item.areacode}
                      </div>
                    </div>
                  </div>
                )}
                itemLayout="horizontal"
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
              <div
                style={{
                  width: '10.5vw',
                  fontWeight: 'bold',
                  marginRight: '40px',
                  fontSize: '15px',
                  border: '1px solid #75a3a3',
                  backgroundColor: '#f0f5f5',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                {t("used-for-profiles")}
              </div>
              <SimpleList
                dataSource={usedProfilesForCode}
                style={{
                  overflowX: 'auto',
                  overflowY: 'auto',
                  maxHeight: '14.5vh',
                  width: '16.5vw',
                  borderColor: '#8b8b8c',
                  borderRadius: '5px',
                }}
                renderItem={(item) => (
                  <div
                    style={{
                      marginLeft: '10px',
                      marginTop: '5px',
                      display: 'flex',
                      padding: '2px',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                      <div
                        style={{
                          width: '14vw',
                          marginRight: '5px',
                          padding: '2px',
                          backgroundColor: 'white',
                          borderRadius: '5px',
                          border: '1px solid #75a3a3',
                        }}
                      >
                        {item.producttype} : {item.productdescription}
                      </div>
                    </div>
                  </div>
                )}
                itemLayout="horizontal"
              />
            </div>

            <div style={{display: 'flex', margin: '3vh 0 0 0', gap: '2vw'}}>
              <Button
                title={t("drawing")}
                style={{borderRadius: '5px'}}
                onClick={handleDrawingModal}
              />
              <Button
                title={'Supplier Info'}
                style={{borderRadius: '5px'}}
                suffixIcon={{ name: 'info' }}
                onClick={handleSupplierInfoModal}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title={`${t("drawing")} for ${selectedEquipment ? `Equipment : ${selectedEquipment}` : `Consumable : ${codeModalTitle}`}`}
          style={{}}
          width={'80%'}
          cancelText={t("cancel")}
          visible={viewDrawing}
          onCancel={() => handleDrawingModalCancel()}
          onOk={() => handleDrawingModalCancel()}
          footer={null}
        >
          <iframe
            src={iFrameSrcForCode}
            title="PDF"
            style={{ marginTop: '1vh', height: '70vh', width: '100%' }} // Set width to 100%
          />
        </Modal>

        <Modal
          title={`${t("Supplier Contact Info:")} SGS`}
          width={'38%'}
          cancelText={t("cancel")}
          visible={showSupplierInfoModal}
          footer={null}
          onCancel={() => handleSupplierInfoModalCancel()}
          onOk={() => handleSupplierInfoModalCancel()}
        >
          <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              background: 'linear-gradient(to top left, #f0f0f5, #33adff34)',
              padding: '15px 20px 20px 20px',
              borderRadius: '5px',
              width: '100%'
            }}
          >
            {supplierValue?.filter(supplierItem => supplierItem.field === 'Mechanical').map((supplierItem, supplierIndex)=>{
            return (
            <div key={supplierIndex} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px', width: '100%' }}>
              <div style={{width: '20%', fontWeight: 'bold', marginRight: '40px', fontSize: '15px', border: '1px solid #75a3a3', backgroundColor: '#f0f5f5', padding: '5px 10px', borderRadius: '5px' }}>
                {supplierItem.field}:
              </div>
                <SimpleList
                  dataSource={supplierItem.contact}
                  style={{overflowX: 'auto', overflowY: 'auto', maxHeight:'14.5vh', width: '100%', borderColor: '#8b8b8c', borderRadius: '5px'}}
                  renderItem={(item) => (
                    <div style={
                              {marginLeft: '10px',
                              marginTop:'5px',
                              display: 'flex',
                              padding: '2px',
                              alignItems: 'center'
                          }}>

                      <div style={{ display: 'flex', alignItems: 'flex-start'}}>

                        <div style={{width: '22vw', marginRight: '5px', padding:'2px', backgroundColor: 'white', borderRadius: '5px', border: '1px solid #75a3a3'}}>
                          {item.email}
                        </div>

                      </div>
                    </div>

                    )}
                  itemLayout="horizontal"
                />
            </div>
            )})}
          </div>
        </Modal>

        <Modal
          title={'RFQ'}
          style={{}}
          width={'80%'}
          okText={t("send-mail")}
          cancelText={t("cancel")}
          visible={showRFQModal}
          onCancel={() => justCloseRfqModal()}
          onOk={() => handleRFQSend()}
          footer = {
                    <div style={{display: 'flex', columnGap: '10px'}}>
                      <NormalPlasmaButton
                        title={t("reset-cart")}
                        prefixIcon={{name: 'refresh'}}
                        onClick={()=> handleRFQModalDelete()}
                      />
                      <NormalPlasmaButton
                        title={t("save-rfq")}
                        prefixIcon={{name: 'save'}}
                        onClick={() => handleRFQModalCancel()}
                      />
                      <NormalPlasmaButton
                        title={t("save-email-rfq")}
                        prefixIcon={{name: 'send'}}
                        onClick={() => handleRFQSend()}
                        loading={sendMailButtonLoading}
                      />
                      <Button
                        title={t("cancel")}
                        type={'ghost'}
                        prefixIcon={{name: 'cancel'}}
                        onClick={() => justCloseRfqModal()}
                      />
                    </div>
                   }
        >
          <iframe
            src={iFrameSrc}
            title="PDF"
            style={{ marginTop: '1vh', height: '70vh', width: '100%' }} // Set width to 100%
          />
        </Modal>

        {children}
      </styled.ShoppingCart>
    </ThemeProvider>
  );
}

export default memo(ShoppingCart) as unknown as typeof ShoppingCart;
